import { Box, Button, Card, CardActions, CardContent, Stack, Typography } from "@mui/material";
import { format, isPast } from "date-fns";
import { NewsData } from "../../Objects/NewsDate";

export interface NewsCardProps {
    newsData: NewsData
    onShowDetail?: (newsData: NewsData) => void
    onRegNewsRelease?: (newsData: NewsData) => void
    onRegNewsLimit?: (newsData: NewsData) => void
    onDelete?: (newsData: NewsData) => void
}

export default function NewsCard({
    newsData,
    onShowDetail,
    onRegNewsRelease,
    onRegNewsLimit,
    onDelete,
}: NewsCardProps): React.ReactElement {
    return (
        <Card
            className={(newsData.delete_flug || (newsData.limit_datetime && isPast(newsData.limit_datetime))) ? "disabledCard" : undefined}
        >
            <CardContent>
                <Stack spacing={1}>
                    <Box>
                        <Typography variant="h3">{newsData.title}</Typography>
                    </Box>
                    <Box>
                        <Typography variant="body2" textAlign={"right"}>登録日時：{newsData.date && format(newsData.date, "yyyy年MM月dd日 HH:mm:ss")}</Typography>
                    </Box>
                    {newsData.release_datetime &&
                        <Box>
                            <Typography variant="body2">公開日時：{format(newsData.release_datetime, "yyyy年MM月dd日 HH:mm:ss")}</Typography>
                        </Box>
                    }
                    {newsData.limit_datetime &&
                        <Box>
                            <Typography variant="body2">終了日時：{format(newsData.limit_datetime, "yyyy年MM月dd日 HH:mm:ss")}</Typography>
                        </Box>
                    }
                </Stack>
            </CardContent>
            <CardActions
                sx={{
                    display: "flex",
                    justifyContent: "right"
                }}
            >
                {onShowDetail &&
                    <Button
                        variant="outlined"
                        onClick={() => {
                            onShowDetail(newsData)
                        }}
                    >詳細</Button>
                }
                {!newsData.release_datetime ?
                    onRegNewsRelease &&
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => {
                            onRegNewsRelease(newsData)
                        }}
                    >公開する</Button>
                    :
                    newsData.limit_datetime ?
                        onRegNewsRelease &&
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => {
                                onRegNewsRelease(newsData)
                            }}
                        >再公開</Button>
                        :
                        onRegNewsLimit &&
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => {
                                onRegNewsLimit(newsData)
                            }}
                        >公開終了</Button>
                }
                {onDelete &&
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={() => {
                            onDelete(newsData)
                        }}
                    >削除</Button>
                }
            </CardActions>
        </Card>
    )
}